import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FieldMap } from 'angular2-query-builder/dist/components';
import { StateMatcherInput } from 'core/http/root';

@Component({
  selector: 'app-matcher-dialog',
  templateUrl: './matcher-dialog.component.html',
  styleUrls: ['./matcher-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MatcherDialogComponent {
  input: StateMatcherInput = this.data
    ? { ...this.data }
    : {
        state: 1,
        ruleSet: { condition: 'and', rules: [] },
        name: '',
      };

  readonly orderFieldMap: FieldMap = Object.fromEntries([
    ['id', 'SETTINGS_CATALOGS.identifier'],
    ['name', 'SENDERS.FORM.name_label'],
  ].map(([field, key]) => {
    const translateService = this.translateService;
    return [field, {
      get name(): string {
        return translateService.instant(key);
      },
      type: 'string',
    }];
  }));

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: StateMatcherInput | null,
    private translateService: TranslateService,
  ) { }

  get isMatcherValid(): boolean {
    return !!this.input.ruleSet && !!this.input.name;
  }
}
